import { ContinentSection, CountryInterface } from "../dto";

export const CONTINENT_SECTIONS: (ContinentSection | CountryInterface)[] = [
    {
        "countryCode": "US",
        "countryName": "United States"
    },
    {
        "countryCode": "CA",
        "countryName": "Canada"
    },
    {
        "continentName": "Latin America & Caribbean",
        "countries": [
            {
                "countryCode": "AI",
                "countryName": "Anguilla"
            },
            {
                "countryCode": "AG",
                "countryName": "Antigua and Barbuda"
            },
            {
                "countryCode": "AR",
                "countryName": "Argentina"
            },
            {
                "countryCode": "AW",
                "countryName": "Aruba"
            },
            {
                "countryCode": "BS",
                "countryName": "Bahamas"
            },
            {
                "countryCode": "BB",
                "countryName": "Barbados"
            },
            {
                "countryCode": "BZ",
                "countryName": "Belize"
            },
            {
                "countryCode": "BM",
                "countryName": "Bermuda"
            },
            {
                "countryCode": "BO",
                "countryName": "Bolivia"
            },
            {
                "countryCode": "BQ",
                "countryName": "Bonaire, Sint Eustatius and Saba"
            },
            {
                "countryCode": "BR",
                "countryName": "Brazil"
            },
            {
                "countryCode": "KY",
                "countryName": "Cayman Islands"
            },
            {
                "countryCode": "CL",
                "countryName": "Chile"
            },
            {
                "countryCode": "MF",
                "countryName": "Collectivity of Saint Martin"
            },
            {
                "countryCode": "CO",
                "countryName": "Colombia"
            },
            {
                "countryCode": "CR",
                "countryName": "Costa Rica"
            },
            {
                "countryCode": "CU",
                "countryName": "Cuba"
            },
            {
                "countryCode": "CW",
                "countryName": "Curacao"
            },
            {
                "countryCode": "DM",
                "countryName": "Dominica"
            },
            {
                "countryCode": "DO",
                "countryName": "Dominican Republic"
            },
            {
                "countryCode": "EC",
                "countryName": "Ecuador"
            },
            {
                "countryCode": "SV",
                "countryName": "El Salvador"
            },
            {
                "countryCode": "GQ",
                "countryName": "Equatorial Guinea"
            },
            {
                "countryCode": "FK",
                "countryName": "Falkland Islands"
            },
            {
                "countryCode": "GF",
                "countryName": "French Guiana"
            },
            {
                "countryCode": "GD",
                "countryName": "Grenada"
            },
            {
                "countryCode": "GP",
                "countryName": "Guadeloupe"
            },
            {
                "countryCode": "GT",
                "countryName": "Guatemala"
            },
            {
                "countryCode": "GY",
                "countryName": "Guyana"
            },
            {
                "countryCode": "HT",
                "countryName": "Haiti"
            },
            {
                "countryCode": "HN",
                "countryName": "Honduras"
            },
            {
                "countryCode": "JM",
                "countryName": "Jamaica"
            },
            {
                "countryCode": "MQ",
                "countryName": "Martinique"
            },
            {
                "countryCode": "MX",
                "countryName": "Mexico"
            },
            {
                "countryCode": "MS",
                "countryName": "Montserrat"
            },
            {
                "countryCode": "NI",
                "countryName": "Nicaragua"
            },
            {
                "countryCode": "PA",
                "countryName": "Panama"
            },
            {
                "countryCode": "PY",
                "countryName": "Paraguay"
            },
            {
                "countryCode": "PE",
                "countryName": "Peru"
            },
            {
                "countryCode": "PR",
                "countryName": "Puerto Rico"
            },
            {
                "countryCode": "BL",
                "countryName": "Saint Barthelemy"
            },
            {
                "countryCode": "KN",
                "countryName": "Saint Kitts and Nevis"
            },
            {
                "countryCode": "LC",
                "countryName": "Saint Lucia"
            },
            {
                "countryCode": "VC",
                "countryName": "Saint Vincent and the Grenadines"
            },
            {
                "countryCode": "SX",
                "countryName": "Sint Maarten"
            },
            {
                "countryCode": "SR",
                "countryName": "Suriname"
            },
            {
                "countryCode": "TT",
                "countryName": "Trinidad and Tobago"
            },
            {
                "countryCode": "TC",
                "countryName": "Turks and Caicos Islands"
            },
            {
                "countryCode": "UY",
                "countryName": "Uruguay"
            },
            {
                "countryCode": "VE",
                "countryName": "Venezuela"
            },
            {
                "countryCode": "VG",
                "countryName": "Virgin Islands, British"
            },
            {
                "countryCode": "VI",
                "countryName": "Virgin Islands, U.S."
            }
        ]
    },
    {
        "continentName": "Africa",
        "countries": [
            {
                "countryCode": "DZ",
                "countryName": "Algeria"
            },
            {
                "countryCode": "AO",
                "countryName": "Angola"
            },
            {
                "countryCode": "BJ",
                "countryName": "Benin"
            },
            {
                "countryCode": "BW",
                "countryName": "Botswana"
            },
            {
                "countryCode": "BF",
                "countryName": "Burkina Faso"
            },
            {
                "countryCode": "BI",
                "countryName": "Burundi"
            },
            {
                "countryCode": "CV",
                "countryName": "Cape Verde"
            },
            {
                "countryCode": "CF",
                "countryName": "Central African Republic"
            },
            {
                "countryCode": "TD",
                "countryName": "Chad"
            },
            {
                "countryCode": "KM",
                "countryName": "Comoros"
            },
            {
                "countryCode": "CG",
                "countryName": "Congo"
            },
            {
                "countryCode": "CD",
                "countryName": "Democratic Republic of the Congo"
            },
            {
                "countryCode": "DJ",
                "countryName": "Djibouti"
            },
            {
                "countryCode": "EG",
                "countryName": "Egypt"
            },
            {
                "countryCode": "ER",
                "countryName": "Eritrea"
            },
            {
                "countryCode": "SZ",
                "countryName": "Eswatini"
            },
            {
                "countryCode": "ET",
                "countryName": "Ethiopia"
            },
            {
                "countryCode": "TF",
                "countryName": "French Southern Territories"
            },
            {
                "countryCode": "GA",
                "countryName": "Gabon"
            },
            {
                "countryCode": "GM",
                "countryName": "Gambia"
            },
            {
                "countryCode": "GH",
                "countryName": "Ghana"
            },
            {
                "countryCode": "GN",
                "countryName": "Guinea"
            },
            {
                "countryCode": "GW",
                "countryName": "Guinea-Bissau"
            },
            {
                "countryCode": "CI",
                "countryName": "Ivory Coast"
            },
            {
                "countryCode": "KE",
                "countryName": "Kenya"
            },
            {
                "countryCode": "LS",
                "countryName": "Lesotho"
            },
            {
                "countryCode": "LR",
                "countryName": "Liberia"
            },
            {
                "countryCode": "LY",
                "countryName": "Libya"
            },
            {
                "countryCode": "MG",
                "countryName": "Madagascar"
            },
            {
                "countryCode": "MW",
                "countryName": "Malawi"
            },
            {
                "countryCode": "ML",
                "countryName": "Mali"
            },
            {
                "countryCode": "MR",
                "countryName": "Mauritania"
            },
            {
                "countryCode": "MU",
                "countryName": "Mauritius"
            },
            {
                "countryCode": "YT",
                "countryName": "Mayotte"
            },
            {
                "countryCode": "MA",
                "countryName": "Morocco"
            },
            {
                "countryCode": "MZ",
                "countryName": "Mozambique"
            },
            {
                "countryCode": "NA",
                "countryName": "Namibia"
            },
            {
                "countryCode": "NE",
                "countryName": "Niger"
            },
            {
                "countryCode": "NG",
                "countryName": "Nigeria"
            },
            {
                "countryCode": "RE",
                "countryName": "Reunion"
            },
            {
                "countryCode": "RW",
                "countryName": "Rwanda"
            },
            {
                "countryCode": "SH",
                "countryName": "Saint Helena"
            },
            {
                "countryCode": "ST",
                "countryName": "Sao Tome and Principe"
            },
            {
                "countryCode": "SN",
                "countryName": "Senegal"
            },
            {
                "countryCode": "SC",
                "countryName": "Seychelles"
            },
            {
                "countryCode": "SL",
                "countryName": "Sierra Leone"
            },
            {
                "countryCode": "SO",
                "countryName": "Somalia"
            },
            {
                "countryCode": "ZA",
                "countryName": "South Africa"
            },
            {
                "countryCode": "SS",
                "countryName": "South Sudan"
            },
            {
                "countryCode": "SD",
                "countryName": "Sudan"
            },
            {
                "countryCode": "TZ",
                "countryName": "Tanzania"
            },
            {
                "countryCode": "TG",
                "countryName": "Togo"
            },
            {
                "countryCode": "TN",
                "countryName": "Tunisia"
            },
            {
                "countryCode": "UG",
                "countryName": "Uganda"
            },
            {
                "countryCode": "EH",
                "countryName": "Western Sahara"
            },
            {
                "countryCode": "ZM",
                "countryName": "Zambia"
            },
            {
                "countryCode": "ZW",
                "countryName": "Zimbabwe"
            }
        ]
    },
    {
        "continentName": "Europe",
        "countries": [
            {
                "countryCode": "AX",
                "countryName": "Aland Islands"
            },
            {
                "countryCode": "AL",
                "countryName": "Albania"
            },
            {
                "countryCode": "AD",
                "countryName": "Andorra"
            },
            {
                "countryCode": "AM",
                "countryName": "Armenia"
            },
            {
                "countryCode": "AT",
                "countryName": "Austria"
            },
            {
                "countryCode": "AZ",
                "countryName": "Azerbaijan"
            },
            {
                "countryCode": "BY",
                "countryName": "Belarus"
            },
            {
                "countryCode": "BE",
                "countryName": "Belgium"
            },
            {
                "countryCode": "BA",
                "countryName": "Bosnia and Herzegovina"
            },
            {
                "countryCode": "BV",
                "countryName": "Bouvet Island"
            },
            {
                "countryCode": "BG",
                "countryName": "Bulgaria"
            },
            {
                "countryCode": "HR",
                "countryName": "Croatia"
            },
            {
                "countryCode": "CZ",
                "countryName": "Czechia"
            },
            {
                "countryCode": "DK",
                "countryName": "Denmark"
            },
            {
                "countryCode": "EE",
                "countryName": "Estonia"
            },
            {
                "countryCode": "FO",
                "countryName": "Faroe Islands"
            },
            {
                "countryCode": "FI",
                "countryName": "Finland"
            },
            {
                "countryCode": "FR",
                "countryName": "France"
            },
            {
                "countryCode": "GE",
                "countryName": "Georgia"
            },
            {
                "countryCode": "DE",
                "countryName": "Germany"
            },
            {
                "countryCode": "GI",
                "countryName": "Gibralta"
            },
            {
                "countryCode": "GR",
                "countryName": "Greece"
            },
            {
                "countryCode": "GL",
                "countryName": "Greenland"
            },
            {
                "countryCode": "GG",
                "countryName": "Guernsey"
            },
            {
                "countryCode": "VA",
                "countryName": "Holy See"
            },
            {
                "countryCode": "HU",
                "countryName": "Hungary"
            },
            {
                "countryCode": "IS",
                "countryName": "Iceland"
            },
            {
                "countryCode": "IE",
                "countryName": "Ireland"
            },
            {
                "countryCode": "IM",
                "countryName": "Isle of Man"
            },
            {
                "countryCode": "IT",
                "countryName": "Italy"
            },
            {
                "countryCode": "JE",
                "countryName": "Jersey"
            },
            {
                "countryCode": "KZ",
                "countryName": "Kazakhstan"
            },
            {
                "countryCode": "LV",
                "countryName": "Latvia"
            },
            {
                "countryCode": "LI",
                "countryName": "Liechtenstein"
            },
            {
                "countryCode": "LT",
                "countryName": "Lithuania"
            },
            {
                "countryCode": "LU",
                "countryName": "Luxembourg"
            },
            {
                "countryCode": "MK",
                "countryName": "Macedonia"
            },
            {
                "countryCode": "MT",
                "countryName": "Malta"
            },
            {
                "countryCode": "MD",
                "countryName": "Moldova"
            },
            {
                "countryCode": "MC",
                "countryName": "Monaco"
            },
            {
                "countryCode": "ME",
                "countryName": "Montenegro"
            },
            {
                "countryCode": "NL",
                "countryName": "Netherlands"
            },
            {
                "countryCode": "NO",
                "countryName": "Norway"
            },
            {
                "countryCode": "PL",
                "countryName": "Poland"
            },
            {
                "countryCode": "PT",
                "countryName": "Portugal"
            },
            {
                "countryCode": "RO",
                "countryName": "Romania"
            },
            {
                "countryCode": "RU",
                "countryName": "Russia"
            },
            {
                "countryCode": "PM",
                "countryName": "Saint Pierre and Miquelon"
            },
            {
                "countryCode": "SM",
                "countryName": "San Marino"
            },
            {
                "countryCode": "RS",
                "countryName": "Serbia"
            },
            {
                "countryCode": "SK",
                "countryName": "Slovakia"
            },
            {
                "countryCode": "SI",
                "countryName": "Slovenia"
            },
            {
                "countryCode": "GS",
                "countryName": "South Georgia and the South Sandwich Islands"
            },
            {
                "countryCode": "ES",
                "countryName": "Spain"
            },
            {
                "countryCode": "SJ",
                "countryName": "Svalbard and Jan Mayen"
            },
            {
                "countryCode": "SE",
                "countryName": "Sweden"
            },
            {
                "countryCode": "CH",
                "countryName": "Switzerland"
            },
            {
                "countryCode": "UA",
                "countryName": "Ukraine"
            },
            {
                "countryCode": "GB",
                "countryName": "United Kingdom"
            }
        ]
    },
    {
        "continentName": "Middle East",
        "countries": [
            {
                "countryCode": "BH",
                "countryName": "Bahrain"
            },
            {
                "countryCode": "CY",
                "countryName": "Cyprus"
            },
            {
                "countryCode": "IR",
                "countryName": "Iran"
            },
            {
                "countryCode": "IQ",
                "countryName": "Iraq"
            },
            {
                "countryCode": "IL",
                "countryName": "Israel"
            },
            {
                "countryCode": "JO",
                "countryName": "Jordan"
            },
            {
                "countryCode": "KW",
                "countryName": "Kuwait"
            },
            {
                "countryCode": "LB",
                "countryName": "Lebanon"
            },
            {
                "countryCode": "OM",
                "countryName": "Oman"
            },
            {
                "countryCode": "PS",
                "countryName": "Palestine"
            },
            {
                "countryCode": "QA",
                "countryName": "Qatar"
            },
            {
                "countryCode": "SA",
                "countryName": "Saudi Arabia"
            },
            {
                "countryCode": "SY",
                "countryName": "Syrian Arab Republic"
            },
            {
                "countryCode": "TR",
                "countryName": "Turkey"
            },
            {
                "countryCode": "AE",
                "countryName": "United Arab Emirates"
            },
            {
                "countryCode": "YE",
                "countryName": "Yemen"
            }
        ]
    },
    {
        "continentName": "Asia",
        "countries": [
            {
                "countryCode": "AF",
                "countryName": "Afghanistan"
            },
            {
                "countryCode": "BD",
                "countryName": "Bangladesh"
            },
            {
                "countryCode": "BT",
                "countryName": "Bhutan"
            },
            {
                "countryCode": "BN",
                "countryName": "Brunei Darussalam"
            },
            {
                "countryCode": "KH",
                "countryName": "Cambodia"
            },
            {
                "countryCode": "CM",
                "countryName": "Cameroon"
            },
            {
                "countryCode": "CN",
                "countryName": "China"
            },
            {
                "countryCode": "HK",
                "countryName": "Hong Kong"
            },
            {
                "countryCode": "IN",
                "countryName": "India"
            },
            {
                "countryCode": "ID",
                "countryName": "Indonesia"
            },
            {
                "countryCode": "JP",
                "countryName": "Japan"
            },
            {
                "countryCode": "KP",
                "countryName": "Korea"
            },
            {
                "countryCode": "KG",
                "countryName": "Kyrgyzstan"
            },
            {
                "countryCode": "LA",
                "countryName": "Lao People's Democratic Republic"
            },
            {
                "countryCode": "MO",
                "countryName": "Macao"
            },
            {
                "countryCode": "MY",
                "countryName": "Malaysia"
            },
            {
                "countryCode": "MV",
                "countryName": "Maldives"
            },
            {
                "countryCode": "MN",
                "countryName": "Mongolia"
            },
            {
                "countryCode": "MM",
                "countryName": "Myanmar"
            },
            {
                "countryCode": "NP",
                "countryName": "Nepal"
            },
            {
                "countryCode": "PK",
                "countryName": "Pakistan"
            },
            {
                "countryCode": "PH",
                "countryName": "Philippines"
            },
            {
                "countryCode": "SG",
                "countryName": "Singapore"
            },
            {
                "countryCode": "KR",
                "countryName": "South Korea"
            },
            {
                "countryCode": "LK",
                "countryName": "Sri Lanka"
            },
            {
                "countryCode": "TW",
                "countryName": "Taiwan"
            },
            {
                "countryCode": "TJ",
                "countryName": "Tajikistan"
            },
            {
                "countryCode": "TH",
                "countryName": "Thailand"
            },
            {
                "countryCode": "TL",
                "countryName": "Timor-Leste"
            },
            {
                "countryCode": "TM",
                "countryName": "Turkmenistan"
            },
            {
                "countryCode": "UZ",
                "countryName": "Uzbekistan"
            },
            {
                "countryCode": "VN",
                "countryName": "Vietnam"
            }
        ]
    },
    {
        "continentName": "Australia and Oceania",
        "countries": [
            {
                "countryCode": "AS",
                "countryName": "American Samoa"
            },
            {
                "countryCode": "AQ",
                "countryName": "Antarctica"
            },
            {
                "countryCode": "AU",
                "countryName": "Australia"
            },
            {
                "countryCode": "IO",
                "countryName": "British Indian Ocean Territory"
            },
            {
                "countryCode": "CX",
                "countryName": "Christmas Island",
            },
            {
                "countryCode": "CC",
                "countryName": "Cocos (Keeling) Islands",
            },
            {
                "countryCode": "CK",
                "countryName": "Cook Islands"
            },
            {
                "countryCode": "FM",
                "countryName": "Federated States of Micronesia"
            },
            {
                "countryCode": "FJ",
                "countryName": "Fiji"
            },
            {
                "countryCode": "PF",
                "countryName": "French Polynesia"
            },
            {
                "countryCode": "GU",
                "countryName": "Guam"
            },
            {
                "countryCode": "HM",
                "countryName": "Heard Island and McDonald Islands"
            }, 
            {
                "countryCode": "KI",
                "countryName": "Kiribati"
            },
            {
                "countryCode": "MH",
                "countryName": "Marshall Islands"
            },
            {
                "countryCode": "NR",
                "countryName": "Nauru"
            },
            {
                "countryCode": "NC",
                "countryName": "New Caledonia"
            },
            {
                "countryCode": "NZ",
                "countryName": "New Zealand"
            },
            {
                "countryCode": "NU",
                "countryName": "Niue"
            },
            {
                "countryCode": "NF",
                "countryName": "Norfolk Island"
            },
            {
                "countryCode": "MP",
                "countryName": "Northern Mariana Islands"
            },
            {
                "countryCode": "PW",
                "countryName": "Palau"
            },
            {
                "countryCode": "PG",
                "countryName": "Papua New Guinea"
            },
            {
                "countryCode": "PN",
                "countryName": "Pitcairn"
            },
            {
                "countryCode": "WS",
                "countryName": "Samoa"
            },
            {
                "countryCode": "SB",
                "countryName": "Solomon Islands"
            },
            {
                "countryCode": "TK",
                "countryName": "Tokelau"
            },
            {
                "countryCode": "TO",
                "countryName": "Tonga"
            },
            {
                "countryCode": "TV",
                "countryName": "Tuvalu"
            },
            {
                "countryCode": "UM",
                "countryName": "United States Minor Outlying Islands"
            },
            {
                "countryCode": "VU",
                "countryName": "Vanuatu"
            },
            {
                "countryCode": "WF",
                "countryName": "Wallis and Futuna"
            },
        ]
    },
]